import 'pages/persons/persons-category-select-modal.tag'
riot.tag2('person-category-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категория</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.parentName}">\n          <label class="control-label">Родительская группа</label>\n          <div class="input-group">\n            <select class="form-control" name="idParent">\n              <option each="{groupsPerson}" value="{id}" __selected="{id == item.idParent}" no-reorder>{title}</option>\n            </select>\n            <div class="input-group-btn">\n              <div class="btn btn-default" onclick="{removeGroup}"><i class="fa fa-times text-danger"></i></div>\n            </div>\n          </div>\n        </div>\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Код категории рассылки</label>\n          <div class="input-group">\n            <input class="form-control" name="emailSettings" type="text" value="{item.emailSettings}">\n            <div class="input-group-btn">\n              <div class="btn btn-default" onclick="{getEmailGroup}" title="Связать с группой рассылки"><i class="fa fa-cogs"></i></div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

function loadGroupPerson(modal) {
    var params = {};
    params.ignoreId = modal.item.id || 0;
    params.parentId = 0;

    modal.groupsPerson = [];
    API.request({
        object: 'ContactCategory',
        method: 'Fetch',
        data: params,
        success: function success(response, xhr) {
            modal.groupsPerson.push({ id: 0, title: "Без родителя" });
            modal.groupsPerson = modal.groupsPerson.concat(response.items);
            modal.update();
        }
    });
}

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.groupsPerson = [];
    modal.item = opts.item || {};

    loadGroupPerson(modal);

    modal.mixin('validation');
    modal.mixin('change');

    modal.rules = {
        name: 'empty'
    };

    modal.getEmailGroup = function (e) {
        var params = {
            id: modal.item.id,
            name: modal.item.name,
            addBook: true
        };
        API.request({
            object: 'ContactCategory',
            data: params,
            method: 'Save',
            success: function success(response) {
                modal.item.emailSettings = response.emailSettings;
                popups.create({ title: 'Успех!', text: 'Контакты синхронизированы с группой рассылки!', style: 'popup-success' });
                modal.update();
            }
        });
    };
    modal.removeGroup = function (e) {
        modal.item.idParent = null;
        modal.item.nameParent = '';
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };
});
});


// WEBPACK FOOTER //
// ./pages/persons/person-category-new-modal.tag